/** Host REST RTK slices and store wiring. Import hooks from feature modules (e.g. `Services/restApi/sipDomainsApi`). */

import { createUiRestClient } from "Services/http/uiRestClient";
import { getApiUrl, getConvUrl, getIngestUrl } from "Services/ProxyConfig";

import type { Middleware } from "@reduxjs/toolkit";

/** regal-voice-api proxy (`/api`). Case conversion on by default for legacy REST shapes. */
export const apiRestApi = createUiRestClient({
    host: getApiUrl(),
}).asHostRestApi({ reducerPath: "apiRestApi" });

/** conversation-service proxy (`/conv`). SIP and convos REST use snake_case on the wire. */
export const convosRestApi = createUiRestClient({
    host: getConvUrl(),
    performCaseConversion: false,
}).asHostRestApi({ reducerPath: "convosRestApi" });

/** ingest proxy (`/api/proxy/ingest`). */
export const ingestRestApi = createUiRestClient({
    host: getIngestUrl(),
}).asHostRestApi({ reducerPath: "ingestRestApi" });

/** All host-scoped REST RTK slices — register reducers and middleware from this list. */
const hostRestApis = [apiRestApi, convosRestApi, ingestRestApi] as const;

export const hostRestApiReducerPaths = hostRestApis.map((api) => api.reducerPath);

export const hostRestApiReducers = Object.fromEntries(hostRestApis.map((api) => [api.reducerPath, api.reducer]));

export const hostRestApiMiddleware: Middleware[] = hostRestApis.map((api) => api.middleware);

type InvalidateTagsOnOptions<TSuccess, TError = TSuccess> = {
    result: unknown;
    success?: readonly TSuccess[];
    error?: readonly TError[];
};

export function invalidateTagsOn<TSuccess, TError = TSuccess>({
    result,
    success = [],
    error = [],
}: InvalidateTagsOnOptions<TSuccess, TError>): readonly TSuccess[] | readonly TError[] {
    return result ? success : error;
}
